var invokeVFunc = function(funcName, _this) {
	var root = _this.$root;
	if (root && root._$v3platform) {
		var v3platform = root._$v3platform();
		var func = v3platform.datasource[funcName];
		if (func) {
			var args = Array.prototype.slice.call(arguments, 2);
			return func.apply(root, args);
		}
	}
};

/**
 * 注册数据源更新事件
 * @param {Object} params
 * {
 * 	vueObj : VueCompoent,//vue对象，
//  *  handler : function(){}//处理
 * }
 * @returns true表示注册事件成功，false表示注册失败
 */
var registerDsUpdateEvent = function(params){
	var vue = params.vueObj;
	if(typeof(vue.$root._$registerDsEvent) == 'function'){
		vue.$root._$registerDsEvent((function(_this){
			return function(){
				var _$attrs = _this.$attrs
				if(_$attrs && _$attrs["___ds___"] && _$attrs["___field___"]){
					var _dsName = _$attrs["___ds___"];
					var _field = _$attrs["___field___"];
					if(_field.indexOf(",") != -1){
						_field = _field.split(",");
					}else{
						_field = [_$attrs["___field___"]];
					}
					var _ds = _this.$root._$getDatasource(_dsName);
					if(_ds != null){
						_ds.on({
							"eventName" : _ds.Events.UPDATE,
							"handler" : function(params) {
								/* 是否改变 */
								var isChange = false;
								/* 旧值 */
								var oldVal = null;
								/* 新值 */
								var newVal = null;
								/* 新数据 */
								var datas = params.resultSet.datas;
								if(datas && datas.length > 0){
									for(var i = 0,len = datas.length;i<len;i++){
										var data = datas[i];
										var changeData = data.getChangedData();
										for(var j = 0,l = _field.length;j<l;j++){
											if(changeData.hasOwnProperty(_field[j])){
												newVal = changeData[_field[j]];
												isChange = true;
											}
										}
										
									}
								}
								datas = params.oldResultSet.datas;
								if(datas && datas.length > 0){
									for(var i = 0,len = datas.length;i<len;i++){
										var data = datas[i];
										for(var j = 0,l = _field.length;j<l;j++){
											oldVal = data[_field[j]];
										}
									}
								}
								if(isChange)
									_this.$nextTick(function(){
										_this.$emit("on-change",newVal,oldVal);
									});
							}
						});
					}
				}
			}
		})(vue));
		return true;
	}
	return false;
}

/**
 * 获取资源图片路径
 */
var getSrcPathFromRes = function(node,value) {
	if(!node.$root._getComponentCode){
		return value;
	}
	var componentCode = node.$root._getComponentCode();
	var path = "itop/resources/" + componentCode + "_" + value;
	var val = window.GlobalVariables ? GlobalVariables.getServerUrl() + "/" + path: path;
	return val;
}
/**
* 获取附件id路径
*/
var getSrcPathFromId2url = function(value) {
	if (value == undefined || value == null || !value || value == "") {
		return;
	}
	var url = "module-operation!executeOperation?operation=FileDown&token=%7B%22data%22%3A%7B%22dataId%22%3A%22" + value + "%22%2C%22ImageObj%22%3A%22" + value + "%22%7D%7D";
	var val = window.GlobalVariables ? GlobalVariables.getServerUrl() + "/" + url: url;
	return val;
}

export default {
	/**
	 * 同步当前行到数据源
	 */
	synCurrentRecordToDs : function(_this, entityCode, newData, oldData) {
		return invokeVFunc('synCurrentRecordToDs', _this, entityCode, newData, oldData);
	},
	/**
	 * 此方法已废弃
	 * 同步当前行到数据源
	 */
	synCurrentIdToDs : function(_this, entityCode, newData, oldData) {
		return invokeVFunc('synCurrentIdToDs', _this, entityCode, newData, oldData);
	},
	/**
	 * 同步选中行到数据源
	 */
	synSelectRecordToDs : function(_this, entityCode, data, isSel) {
		return invokeVFunc('synSelectRecordToDs', _this, entityCode, data, isSel);
	},
	registerCurrentHandler : function(_this, handler) {
		return  invokeVFunc('registerCurrentHandler', _this, handler);
	},
	registerSelectHandler : function(_this, handler) {
		return  invokeVFunc('registerSelectHandler', _this, handler);
	},
	markDsMultipleSelect : function(_this, entityCode) {
		return  invokeVFunc('markDsMultipleSelect', _this, entityCode);
	},
	/* 获取vui版本，2.0为新版vui */
	getVuiVersion : function(nowVue){
		if(nowVue && nowVue.$root){
			return nowVue.$root.vui_version;
		}
		return null;
	},
	getCurrentRecord:function(_this, entityCode){
		return invokeVFunc('getCurrentRecord', _this, entityCode);
	},
	getSelectedRecords:function(_this, entityCode){
		return invokeVFunc('getSelectedRecords', _this, entityCode);
	},
	isSelected : function(_this, entityCode, record){
		return invokeVFunc('isSelectedRecord', _this, entityCode, record);
	},
	isCurrent : function(_this, entityCode, record){
		return invokeVFunc('isCurrentRecord', _this, entityCode, record);
	},
	markMultipleDs : function(_this, entityCode){
		return invokeVFunc('setDsMultiSelect', _this, entityCode);
	},
	registerDsUpdateEvent : registerDsUpdateEvent,
	getSrcPathFromRes : getSrcPathFromRes,
	getSrcPathFromId2url : getSrcPathFromId2url,
	genUUID : function genUUID(){
		function S4() {
		  return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
		}
		return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
	},
	isRunInV3Service : function(params){
		if(!window.VMetrix || !window.VMetrix.loadBundles){
			return false;
		}
		// throw new Error("未运行在V3服务内，无法执行操作.");
		return true;
	},
	v3Log : function(type,msg){
		if(window && window.console){
			switch(type){
				case "warn":
					window.console.warn(msg);
					break;
				case "error":
					window.console.error(msg)
					break;
				default :
					window.console.log(msg);
					break;
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/v3platform.js